export default {
  ratings: (state) => state.ratings,
  rating: (state) => state.rating,
  loading: (state) => state.loading,
}
